import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ArtistDataProvider } from "../../context/ArtistDataContext";
import ArtistDashboard from "./pages/ArtistDashboard";
import Onboarding from "./pages/Onboarding";
import Notifications from "./pages/Notifications";
import Messages from "./pages/Messages";
import Availability from "./pages/Availability";
import Calendar from "./pages/Calendar";
import Settings from "./pages/Settings";
import Earnings from "./pages/Earnings";
import Groups from "./pages/Groups";
import BulletinBoard from "./pages/BulletinBoard";

const ArtistRoutes = () => {
  return (
    <ArtistDataProvider>
      <Routes>
      <Route path="/" element={<ArtistDashboard />} />

      {/* Onboarding */}
      <Route path="/onboarding" element={<Onboarding />} />

      {/* Communication */}
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/messages" element={<Messages />} />

      {/* Availability */}
      <Route path="/availability" element={<Availability />} />

      {/* Calendar */}
      <Route path="/calendar" element={<Calendar />} />

      {/* Groups */}
      <Route path="/groups" element={<Groups />} />

      {/* Bulletin Board */}
      <Route path="/bulletinBoard" element={<BulletinBoard />} />

      {/* Earnings */}
      <Route path="/earnings" element={<Earnings />} />

      {/* Settings */}
      <Route path="/settings" element={<Settings />} />

      {/* Future artist routes will go here */}
      {/* <Route path="/profile" element={<MyProfile />} /> */}
      {/* <Route path="/profile/edit" element={<EditProfile />} /> */}
      {/* <Route path="/analytics" element={<Analytics />} /> */}

      {/* Redirect unknown routes to dashboard */}
      <Route path="*" element={<Navigate to="/artist" replace />} />
      </Routes>
    </ArtistDataProvider>
  );
};

export default ArtistRoutes;
